import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";

import { type AppState } from "@client/types/AppState";
import Component, { type DoneProps } from "./component";

const makeMapStateToProps = () => {
  return (state: AppState, props: RootContainerProps): DoneProps => {
    return {
      ...props
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
